import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as toastrReducer } from "react-redux-toastr";

import user from "./user";
import account from "./account";
import contactMethods from "./contactMethods";
import preferences from "./preferences";
import globals from "./globals";
import settings from "./settings";
import search from "./search";
import active from "./active";
import reports from "./reports";
import tenants from "./tenants";
import cpp from "./cpp";
import config from "./config";

const createRootReducer = (history: any) => {
  const appReducers = combineReducers({
    router: connectRouter(history),
    tenants, // Tenant Options
    cpp, // User's CPP State
    config, // User's Config Options (keypair)
    active, // Current User's Active State
    user, // user state
    account, // account state
    contactMethods, // contact methods state
    preferences, // preference state
    globals, // global state
    settings, // application settings
    search, // account search results
    reports, // User's reports state
    toastr: toastrReducer, // Toaster Messages
  });

  return (state: any, action?: any) => {
    if (action.type === "RESET_APP") {
      // Force reducers to reload from initialStates
      state = undefined;

      // TODO: bug, if you refresh browser, signout button does not work
      // clearing sessionStorage does nothing...
    }

    return appReducers(state, action);
  };
};

export default createRootReducer;
